import Vue from 'vue';
import Component from 'vue-class-component';
import { ED_CONTEXT_MENU, EdContextMenuModel} from '../../ed-context-menu.plugin';
import EdContextMenuItems from '../ed-context-menu-items/ed-context-menu-items.vue';
import EdContextMenuBlank from '../ed-context-menu-blank/ed-context-menu-blank.vue';
import EdContextMenuNav from '../ed-context-menu-nav/ed-context-menu-nav.vue';
import { ED_CONTEXT_MENU_DIRECTIONS } from '../../ed-context-menu.values';

@Component({
  name: 'ed-context-menu',
  components: {
    EdContextMenuItems,
    EdContextMenuBlank,
    EdContextMenuNav
  }
})
export default class EdContextMenu extends Vue {

  public customClass: string = '';
  public shown: boolean = false;
  public isMounted: boolean = false;
  public position = { x: 0, y: 0 };
  public menuType: string = '';
  public options: any = {};
  public cb: Function = null;
  public orientation: string = '';
  public menuContextID: number = 0;
  public offsetY: number = 30;
  public offsetX: number = 0;
  public headerComponent: string = '';
  public backdrop: boolean = false;
  public darkMode: boolean = false;

  get positionMenu(): any {
    return { 'left': `${(this.position.x + this.offsetX)}px`, 'top': `${ this.position.y + this.offsetY }px` };
  }

  get containerClass() {
    return {
      'ed-context-menu-container--shown': this.backdrop
    };
  }

  get edContextClass() {
    let custom = this.customClass ? this.customClass : 'custom';
    return {
      [custom]: true,
      'ed-context-menu--visible': this.shown,
    }
  }

  public show() {
    setTimeout(() => {
      this.setVerticalOrientation();
      this.setHorizontalOrientation();
      window.addEventListener('click', this.checkInsideClick);
      window.addEventListener('resize', this.hide);
      this.shown = true;
    }, 100);
  }

  public setVerticalOrientation() {
    let content: any = this.$el.querySelector('.ed-context-menu__content');
    if(content) {
      content.style.height = 'auto';
      let maxHeight = (window.innerHeight - 30);
      let yPosition = this.position.y;
      let menuHeight = content.scrollHeight;
      let notBottomSpace = (maxHeight - (yPosition + menuHeight)) < 0;
      let notTopSpace = yPosition - menuHeight < 0;

      if(notBottomSpace && notTopSpace) {
        let spaceAvailable = (maxHeight - yPosition - 50);
        content.style.height = `${spaceAvailable}px`;
        this.customClass += ' ed-context-menu__scroll';
        this.offsetY = 30;
      } else if(notBottomSpace) {
        this.orientation = ED_CONTEXT_MENU_DIRECTIONS.BOTTOM_TO_TOP.code;
        this.customClass += ' ed-context-menu__orientation-up';
        this.offsetY = 0;
      } else {
        this.orientation = ED_CONTEXT_MENU_DIRECTIONS.TOP_TO_BOTTOM.code;
        this.offsetY = 30;
      }
    }
  }

  public setHorizontalOrientation() {
    let content: any = this.$el.querySelector('.ed-context-menu__content');
    if (!content || this.offsetX !== 0) return;
    const windowWidth = document?.body?.offsetWidth || 0;
    const contentTotalWidth = this.position.x + content.offsetWidth;
    if (contentTotalWidth > windowWidth) {
      this.offsetX = -(contentTotalWidth - windowWidth);
    }
  }

  public checkInsideClick(e) {
    let found = false;
    let path = e.path || (e.composedPath && e.composedPath());
    path.forEach((el) => {
      if(el.id == 'EdContextMenu') {
        found = true;
      }
    });
    if (!found){
     this.hide();
    }
  }

  public hide() {
    this.shown = false;
    this.customClass = '';
    window.removeEventListener('click', this.checkInsideClick);
    window.removeEventListener('resize', this.hide);
    this.backdrop = false;
    this.isMounted = false;
  }


  mounted() {
    this.menuContextID = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    this.$EdContextMenu.$on(ED_CONTEXT_MENU.EVENTS.SHOW_CONTEXT_MENU, ({params = new EdContextMenuModel({}), cb = () => {}}) => {
      if (this.shown) {
        this.hide();
      }
      this.cb = cb;
      this.menuType = params.type;
      this.position = params.position;
      this.options = params.options;
      this.customClass = params.className;
      this.offsetX = params.offsetX;
      this.headerComponent = params.headerComponent;
      this.backdrop = params.backdrop;
      this.isMounted = true;
      this.darkMode = params.darkMode;
      this.show();
    });


    this.$EdContextMenu.$on(ED_CONTEXT_MENU.EVENTS.CLOSE_CONTEXT_MENU, (optionSelected = {}) => {
      if (this.cb) {
        this.cb(optionSelected);
      }
      this.hide();
    });

    this.$EdContextMenu.$on(ED_CONTEXT_MENU.EVENTS.UPDATE_OPTIONS_CONTEXT_MENU, (options = []) => {
      if (options.length === 0) {
        return;
      }
      this.options = options;
    });
  }

}
